import { useMemo } from "react";
import { useSelector } from "react-redux";

const HY_PROTOCOLS = new Set(["HY12N24", "HY12N12", "350KHY"]);

export default function useIsHyIv(SelInverter) {
  const Iv_list = useSelector((state) => state.Iv_list || {});

  const isHy = useMemo(() => {
    if (!Iv_list.seq || !Array.isArray(Iv_list.seq)) return false;
    const index = Iv_list.seq.findIndex((seq) => seq === SelInverter);
    const protocol = Iv_list.iv_protocol?.[index] || "";
    return HY_PROTOCOLS.has(protocol.toUpperCase());
  }, [Iv_list, SelInverter]);

  return isHy;
}
